import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllSchools = (page: number): Promise<unknown> => {
  return get(`${BASE_URL}/super/schools?page=${page}&limit=8`)
}
export const getAllSchoolsForUsers = (): Promise<unknown> => {
  return get(`${BASE_URL}/super/schools`)
}
export const getAllSchoolsForGroups = (): Promise<unknown> => {
  return get(`${BASE_URL}/super/schools?search=GROUP&searchBy=role`)
}

export interface createSchoolType {
  name: string

  addressLineOne: string
  addressLineTwo: string
  logo?: string
  brandConfig: {
    colors: string
    fonts: string
  }
}

export const createSchoolApi = (data: createSchoolType): Promise<unknown> => {
  return post(`${BASE_URL}/super/schools`, data, null)
}

export const updateSchoolApi = (
  data: createSchoolType,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/super/schools/${id}`, data, null)
}
export const updateSchoolRoleApi = (
  role: string,
  id: string
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/super/schools/${id}/change-role`,
    {
      role: role,
    },
    null
  )
}

export const getMeetingById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/meetings/${id}`)
}

export const approveAndRejectSchool = (
  data: string,
  id: string
): Promise<unknown> => {
  return post(
    `${BASE_URL}/super/schools/${id}/verification`,
    {
      verificationStatus: data,
    },
    null
  )
}

export const deleteSchool = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/super/schools/${id}`, null)
}

export const getSuperAllRoles = (): Promise<unknown> => {
  return get(`${BASE_URL}/super/user-roles`)
}

export const getSchoolFeaturesById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/super/schools/${id}/features`)
}

export const updateSchoolFeatures = (
  permission: string[],
  id: string
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/super/schools/${id}/features`,
    {
      permissions: permission,
    },
    null
  )
}
